import { useTheme } from '@emotion/react';
import {
  Box,
  LinearProgress,
  Typography,
  linearProgressClasses,
  styled,
  useMediaQuery,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import {
  MdOutlinePauseCircleFilled,
  MdOutlinePlayCircleFilled,
  MdOutlineStopCircle,
} from 'react-icons/md';
import { PiMusicNoteLight } from 'react-icons/pi';
import { Unity, useUnityContext } from 'react-unity-webgl';
import {
  GetTouchDevices,
  htmlToImageConvert,
  htmlToImageConverter,
  startRecording,
  wideScreen,
} from '../../../utils';
import ShareButton from '../../ShareButton';
import './ModelLoader.css';
import { ShareDialog, UploadDialog } from '../../ShareDialog/ShareDialog';
import ModelToolAudio from '../../ModelToolAudio';
import ModelTool from '../../ModelTool';
import { GiShadowFollower } from 'react-icons/gi';
import { BsShare } from 'react-icons/bs';
import { ConvertingVideoModal } from '../../ConvertingVideoModal/ConvertingVideoModal';

function ApeUnity({
  id,
  mode = 'animate',
  animation = '',
  environment = '',
  jsonObject = {},
  envloaded,
  setEnvloaded,
  localEnvArray,
  setLocalEnvArray,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [modelLoaded, setModelLoaded] = useState(false);

  const [converting, setConverting] = useState(false);
  const [openShare, setOpenShare] = useState(false);
  const [fullScreen, setFullScreen] = useState(false);
  const [recording, setRecording] = useState(false);
  const [audioSrc, setAudioSrc] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const [uploadOpen, setUploadOpen] = useState(false);
  const handleAudioIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const fileInputRef = useRef(null);
  const [audioName, setAudioName] = useState('Audio');
  const handleAudioUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setAudioName(file.name);
      setUploadOpen(false);
      const reader = new FileReader();
      reader.onload = (e) => {
        setAudioSrc(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };
  useEffect(() => {
    const audioElement = audioRef.current;

    const handlePlay = () => {
      setIsPlaying(true);
    };

    const handlePause = () => {
      setIsPlaying(false);
    };

    if (audioElement) {
      audioElement.addEventListener('play', handlePlay);
      audioElement.addEventListener('pause', handlePause);
    }

    return () => {
      if (audioElement) {
        audioElement.removeEventListener('play', handlePlay);
        audioElement.removeEventListener('pause', handlePause);
      }
    };
  }, [audioRef]);
  function handleCacheControl(url) {
    if (url.match(/\.data/) || url.match(/\.bundle/)) {
      return 'must-revalidate';
    }
    if (url.match(/\.data/)) {
      return 'immutable';
    }
    if (url.match(/\.mp4/) || url.match(/\.wav/)) {
      return 'immutable';
    }
    return 'no-store';
  }
  const unity = useUnityContext({
    dataUrl:
      'https://storage.googleapis.com/mutant-honds/newBuild/MutantHounds.data.unityweb?quere=' +
      new Date().getTime(),
    codeUrl:
      'https://storage.googleapis.com/mutant-honds/newBuild/MutantHounds.wasm.unityweb?quere=' +
      new Date().getTime(),
    loaderUrl:
      'https://storage.googleapis.com/mutant-honds/newBuild/MutantHounds.loader.js?quere=' +
      new Date().getTime(),
    frameworkUrl:
      'https://storage.googleapis.com/mutant-honds/newBuild/MutantHounds.framework.js.unityweb?quere=' +
      new Date().getTime(),
    // loaderUrl: '/webgl/Build/MutantHounds.loader.js',
    // frameworkUrl: '/webgl/Build/MutantHounds.framework.js.unityweb',
    // dataUrl: '/webgl/Build/MutantHounds.data.unityweb',
    // codeUrl: '/webgl/Build/MutantHounds.wasm.unityweb',
    cacheControl: handleCacheControl,
    streamingAssetsUrl: '/webgl/StreamingAssets',
    webglContextAttributes: {
      preserveDrawingBuffer: true,
    },
  });
  const [shaders, setShaders] = useState(null);

  const handleSelectShader = (shader) => {
    setShaders(shader);
  };
  const [duration, setDuration] = useState(10);
  const [downloadType, setDownloadType] = useState('HighRes');
  const elementRef = React.useRef(null);

  const onDownlaod = async (fileName, dur) => {
    if (mode === 'animate') {
      if (audioRef.current) {
        audioRef.current.play();
      }
      setOpenShare(false);
      startRecording(
        'videoAnimation',
        fileName ? fileName : '',
        (e) => setRecording(e),
        '',
        () => {},
        duration,
        audioRef,
        audioRef.current ? true : false,
        (e) => {
          setConverting(e);
        },
        downloadType,
        id
      );
    } else {
      setOpenShare(false);
      if (!GetTouchDevices() && !wideScreen()) {
        setFullScreen(true);
        unity.requestFullscreen(true);
        setTimeout(() => {
          htmlToImageConvert(fileName, elementRef, () => {
            setFullScreen(false);
            unity.requestFullscreen(false);
          });
        }, 1000);
      } else {
        htmlToImageConvert(fileName, elementRef);
      }
    }
  };

  const screendimension = window.screen;
  const modelHeight =
    screendimension?.height - screendimension?.height * (27 / 100);
  const modalContainWidth =
    screendimension.width - screendimension.width * (35 / 100);
  const modalWidth = modelHeight * 1.85;

  useEffect(() => {
    unity?.addEventListener('EnvlLoaded', (e) => {
      if (e[0] == 1) {
        setLocalEnvArray([...localEnvArray, environment]);
        if (environment == e.slice(1)) {
          unity?.sendMessage('Manager', 'ChangeEnviroment', environment);
        }
        return setEnvloaded(true);
      }
      setEnvloaded(false);
    });
    unity?.addEventListener('NFTLoaded', (e) => {
      if (e === 1) {
        setModelLoaded(true);
      }
    });
    return () => {
      unity?.removeEventListener('EnvlLoaded', () => {});
      unity?.removeEventListener('NFTLoaded', () => {});
    };
  }, [
    unity?.addEventListener,
    unity?.removeEventListener,
    window,
    environment,
  ]);

  useEffect(() => {
    if (unity?.isLoaded && animation && modelLoaded) {
      unity?.sendMessage('Manager', 'ChangeAnimation', animation);
    }
  }, [unity?.isLoaded, animation, modelLoaded]);

  useEffect(() => {
    if (unity?.isLoaded && shaders) {
      unity?.sendMessage('Manager', shaders);
    }
  }, [unity?.isLoaded, shaders]);

  useEffect(() => {
    if (unity?.isLoaded && environment && modelLoaded) {
      if (localEnvArray.includes(environment)) {
        unity?.sendMessage('Manager', 'ChangeEnviroment', environment);
      } else {
        envloaded &&
          unity?.sendMessage('Manager', 'LoadEnviroment', environment);
      }
    }
    // eslint-disable-next-line
  }, [unity?.isLoaded, environment, modelLoaded]);

  useEffect(() => {
    console.log('jsonobject value=>', jsonObject);
    if (unity?.isLoaded && jsonObject) {
      unity?.sendMessage(
        'Manager',
        'IsDesktop',
        GetTouchDevices() ? 'false' : 'true'
      );
      unity?.sendMessage(
        'Manager',
        'ReceiveJsonValues',
        JSON.stringify({
          ...jsonObject,
        })
      );
    }
    // eslint-disable-next-line
  }, [unity?.isLoaded, jsonObject]);

  const handleShare = () => {
    setOpenShare(!openShare);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        margin: 'auto',
        alignItems: 'center',
        width: '100%',
      }}
    >
      {!unity?.isLoaded && (
        <Box
          sx={{
            width: isMobile ? '100%' : '70vw',
            position: 'absolute',
            display: unity?.isLoaded ? 'none' : 'flex',
            height: isMobile ? '100%' : '70vh',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <img
            width={isMobile ? '100px' : '140px'}
            className="blnking-animation"
            src="https://ishrostorage.blob.core.windows.net/mutant-3d/model-loader.png"
          />
        </Box>
      )}
      <UploadDialog
        open={uploadOpen}
        setOpen={setUploadOpen}
        setAudioName={setAudioName}
        audioName={audioName}
        setAudioSrc={setAudioSrc}
        onUpload={() => {
          if (audioRef.current) {
            audioRef.current.pause();
          }
          handleAudioIconClick();
        }}
      />
      <input
        type="file"
        accept=".mp3,.wav,.aac,.flac,.ogg,.m4a"
        ref={fileInputRef}
        onChange={handleAudioUpload}
        style={{ display: 'none' }}
      />
      <audio ref={audioRef} src={audioSrc} loop style={{ display: 'none' }} />
      <ShareDialog
        mode={mode}
        duration={duration}
        setDuration={setDuration}
        setDownloadType={setDownloadType}
        downloadType={downloadType}
        openShare={openShare}
        setOpenShare={setOpenShare}
        onTwitterShare={() => {}}
        onFBShare={() => {}}
        onDownlaod={(e, a) => onDownlaod(e, a)}
      />
      {converting && (
        <ConvertingVideoModal
          open={converting}
          duration={duration}
          downloadType={downloadType}
        />
      )}
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            zIndex: 10,
            display: 'flex',
            p: isMobile ? 0.5 : 1,
            pb: isMobile ? 1 : 2,
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: isMobile ? 'flex-start' : 'flex-end',
            background: 'rgba(0,0,0,0.8)',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
              position: 'relative',
              top: 'auto',
              marginTop: '10px',
              zIndex: 'auto',
              background: 'transparent',
              alignItems: 'center',
            },
          }}
        >
          <Box sx={{ mx: isMobile ? 0.5 : 1, my: isMobile ? 0.5 : 0 }}>
            <ModelToolAudio
              icon={PiMusicNoteLight}
              startIcon={
                audioSrc
                  ? isPlaying
                    ? MdOutlinePauseCircleFilled
                    : MdOutlinePlayCircleFilled
                  : null
              }
              stopIcon={MdOutlineStopCircle}
              name={audioName.length > 30 ? audioName.slice(0, 29) : audioName}
              stopIconClick={() => {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
              }}
              startIconClick={() => {
                isPlaying ? audioRef.current.pause() : audioRef.current.play();
              }}
              endIconClick={() => {
                if (audioRef.current) {
                  audioRef.current.pause();
                }
                setUploadOpen(true);
              }}
              onClickAction={() => {
                if (isPlaying && audioRef.current) {
                  audioRef.current.pause();
                }
                setUploadOpen(true);
              }}
            />
          </Box>
          <Box sx={{ mx: isMobile ? 0.5 : 1, my: isMobile ? 0.5 : 0 }}>
            <ModelTool
              icon={GiShadowFollower}
              shaders={[
                { key: 'Default Shader', value: 'DefaultShader' },
                { key: 'Toon Shader', value: 'ToonShader' },
                { key: 'Dissolve Shader', value: 'DissolveShader' },
                { key: 'Holo Shader', value: 'HoloShader' },
                { key: 'Ghost Shader', value: 'GhostShader' },
              ]}
              onSelectShader={handleSelectShader}
              name="Choose shader"
            />
          </Box>
          <Box sx={{ mx: isMobile ? 0.5 : 1, my: isMobile ? 0.5 : 0 }}>
            <ModelTool
              icon={BsShare}
              onClickAction={handleShare}
              name="Share"
            />
          </Box>
        </Box>
        <Box
          ref={elementRef}
          onDoubleClick={() => {
            fullScreen
              ? unity.requestFullscreen(false)
              : unity.requestFullscreen(true);
          }}
          sx={{
            width: fullScreen ? '100vw' : '100%',
            border: recording ? '4px solid red' : '',
            height: fullScreen
              ? '100vh'
              : isMobile
                ? '100%'
                : { xl: '67vh', lg: '66vh', md: '64vh' },
          }}
          id="videoAnimation"
        >
          <Unity
            style={{
              width: '100%',
              borderRadius: isMobile ? '0.5rem' : '0.8vw',
              height: '100%',
            }}
            unityProvider={unity?.unityProvider}
          />
        </Box>
      </div>
    </Box>
  );
}

export default ApeUnity;
